module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.9f916e330c478bbfa2a0.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/resources/theme/custom_omega/fonts/roboto-v15-latin-regular.eot
// module id = ../../../../../resources/theme/custom_omega/fonts/roboto-v15-latin-regular.eot
// module chunks = 2